import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "height100 d-flex justify-center align-center text-center",
  style: {"font-size":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.errorLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          color: "primary",
          indeterminate: "",
          size: 200
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("手続きを進めています...", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.errorLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 1,
          color: "primary",
          indeterminate: "",
          size: 200
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("エラー処理を実行しています...", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}